import { defineMessages } from 'react-intl'

const scope = 'app.containers.ErrorPage'

export default defineMessages({
  errorMessages: {
    error500: {
      id: `${scope}.errorMessages.error500`,
      defaultMessage: 'Internal Server Error',
    },
    error401: {
      id: `${scope}.errorMessages.error401`,
      defaultMessage: 'Access denied, please contact your project administrator.',
    },
  },
})
